import {Trans} from 'react-i18next'

import {Button} from '@sdox/ui'

export interface BlockErrorProps {
  resetError?: () => void
}

export const BlockError = (props: BlockErrorProps) => (
  <div className={'flex flex-col gap-spacing-24'}>
    <div className={'flex justify-center'}>
      <h3 className={'text-h3'}>
        <span
          role={'img'}
          aria-label={'X'}
        >
          ❌
        </span>
        {' '}
        <Trans i18nKey={'common:error.unknown'}/>
      </h3>
    </div>
    {props.resetError ? (
      <div className={'flex justify-center'}>
        <Button
          size={'small'}
          variant={'outline'}
          onClick={props.resetError}
        >
          Erneut probieren
        </Button>
      </div>
    ) : null}
  </div>
)
